import { TeamHeading } from "@/components/Layout/Parts";
import ThumbnailsGenerator from "./components/ThumbnailsGenerator";

const Thumbnails = () => {
  return (
    <>
      <TeamHeading />
      <ThumbnailsGenerator />
    </>
  );
};

export default Thumbnails;
